import { callGetApi, callPutApi, callPostApi, callDeleteApi } from '../apiCallerProxy';
import { dynamicReportApiFactory } from './dynamicReportApiFactory';

export const dynamicReportApi = dynamicReportApiFactory({
    callGetApi,
    callPutApi,
    callPostApi,
    callDeleteApi,
});
